import { useState, useEffect, useContext } from 'react';
import { ToastContext } from '../../../../contexts/ToastContext';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../../../../components/ui/dialog';
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';

import { useParams } from 'react-router-dom';
import apiEmpresa from '../../../../services/apis/apiEmpresa';
import apiUnidade from '../../../../services/apis/apiUnidade';
import PaginationBar from '../../../../components/common/PaginationBar';
import { getParentMap } from '../../../../funcs/getParent';
import apiEnum from '../../../../services/apis/apiEnum';
import apiMarca from '../../../../services/apis/apiMarca';
import apiModelo from '../../../../services/apis/apiModelo';
import apiSistemaAguaGelada from '../../../../services/apis/apiSistemaAguaGelada';
import apiRegimes from '../../../../services/apis/apiRegimes';

export default function ListaSistemasAguaGelada({
	atualizarLista,
	pesquisar,
	funcaoModalController,
	onClose
}) {
	const [nome, setNome] = useState('');
	const [potencia, setPotencia] = useState(0);
	const [acionamento, setAcionamento] = useState('');
	const [vazao, setVazao] = useState(0);
	const [temperaturaEntrada, setTemperaturaEntrada] = useState(0);
	const [temperaturaSaida, setTemperaturaSaida] = useState(0);
	const [tiposAcionamento, setTiposAcionamento] = useState([]);

	const [idEditar, setIdEditar] = useState();
	const [itemRemovido, setItemRemovido] = useState();
	const [idRemover, setIdRemover] = useState();
	const [regimeId, setRegimeId] = useState(0);
	const [listaRegimes, setListaRegimes] = useState([]);
	const [marcaId, setMarcaId] = useState(0);
	const [modeloId, setModeloId] = useState(0);
	const [listaMarcas, setListaMarcas] = useState([]);
	const [listaModelos, setListaModelos] = useState([]);
	const { page } = useParams();
	const [pagination, setPagination] = useState();
	const [listaSistemasAguaGelada, setListaSistemasAguaGelada] = useState([]);
	const funcaoModal = funcaoModalController.funcaoModal;

	const { erro, sucesso } = useContext(ToastContext);

	function limparInputs() {
		setNome('');
		setRegimeId(0);
	}
	useEffect(() => {
		apiSistemaAguaGelada.fetchApi(page).then((res) => {
			setListaSistemasAguaGelada(res.data.items);
			setPagination(res.data);
		});
		apiEnum.getAcionamentos().then(res => {
			setTiposAcionamento(res.data);
		});
		apiMarca.fetchApi().then(res => {
			setListaMarcas(res.data);
		});
		apiRegimes.getByUnidadeId().then(res => {
			setListaRegimes(res.data);
		});
	}, [page]);

	useEffect(() => {
		marcaId !== undefined &&
			!isNaN(marcaId) &&
			apiModelo.fetchApi(marcaId, 'Sistema água').then(res => {
				setListaModelos(res.data);
			})
	}, [marcaId]);

	function deletar(id) {
		apiSistemaAguaGelada
			.deleteApi(id)
			.then((res) => {
				atualizarLista();
				sucesso('Sistema água deletado com sucesso!');
			})
			.catch((error) => {
				console.error(error.message);
				erro('Erro ao deletar sistema água!');
			});
	}

	function enviar(e) {
		e.preventDefault();

		const sistemaAgua = {
			nome: nome,
			regimeId: parseInt(e.target.regimeId.value),
			acionamento: acionamento,
			vazao: parseFloat(vazao),
			temperaturaEntrada:parseFloat(temperaturaEntrada),
			temperaturaSaida:parseFloat(temperaturaSaida),
			potencia:parseFloat(potencia),
			modeloId:parseInt(modeloId)
		};

		if (funcaoModal === 'Adicionar') {
			apiSistemaAguaGelada
				.postApi(sistemaAgua)
				.then((res) => {
					limparInputs();
					sucesso('Sistema de água adicionado com sucesso!');
					atualizarLista();
					onClose();
				})
				.catch((error) => {
					erro('Erro ao adicionar sistema de água!');
					console.error(error.message);
				});
		} else if (funcaoModal === 'Editar') {
			apiSistemaAguaGelada
				.putApi(idEditar, sistemaAgua)
				.then((res) => {
					limparInputs();
					atualizarLista();
					sucesso('Sistema de água editado com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao editar sistema de água!');
				});
		}
	}



	return (
		<>
			<Dialog>
				<div className="w-full flex flex-col items-center mt-[40px] md:px-[200px]">
					<table className="w-full">
						<thead className="border-b w-full">
							<tr>
								<th className="text-[25px] pl-[10px] text-start">
									Nome
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Regime
								</th>
							</tr>
						</thead>
						<tbody>
							{listaSistemasAguaGelada.map(
								(sistemaAguaGelada, i) =>
									sistemaAguaGelada.nome
										.toUpperCase()
										.startsWith(
											pesquisar.toUpperCase()
										) && (
										<tr
											className="border-b hover:bg-gray-200 hover:bg-opacity-5"
											key={i}
										>
											<td className="pl-[10px] text-[20px]">
												{
													sistemaAguaGelada.nome
												}
											</td>

											<td className="flex justify-between py-1">
												<span className="text-[20px] pl-[10px]">
												{listaRegimes.find(regime => regime.id === sistemaAguaGelada.regimeId)?.nome || 'N/A'}
												</span>
												<span className="flex">
													<AlertDialogTrigger>
														<div
															onClick={() => {
																const regimeId = sistemaAguaGelada.regimeId;

																setIdEditar(
																	sistemaAguaGelada.id
																);
																apiModelo.getById(sistemaAguaGelada.modeloId).then(res => {
																	const modelo = res.data;
																	setMarcaId(modelo.marcaId);
																	setModeloId(modelo.id);
																})
																setNome(
																	sistemaAguaGelada.nome
																);

																setAcionamento(
																	sistemaAguaGelada.acionamento.replaceAll("_", " ")

																);
																setPotencia(
																	sistemaAguaGelada.potencia
																);
																setTemperaturaEntrada(
																	sistemaAguaGelada.temperaturaEntrada
																);

																setTemperaturaSaida(
																	sistemaAguaGelada.temperaturaSaida
																);
																setVazao(
																	sistemaAguaGelada.vazao
																);
															
																setRegimeId(
																	regimeId
																);

																funcaoModalController.setFuncaoModal(
																	'Editar'
																);
															}}
														>
															<i
																className="fa-solid fa-pen-to-square text-[18px] hover:text-lightBlue"
																title="Editar"
															></i>
														</div>
													</AlertDialogTrigger>
													<DialogTrigger>
														<div
															className="mx-2.5"
															onClick={() => {
																setItemRemovido(
																	sistemaAguaGelada.nome
																);
																setIdRemover(
																	sistemaAguaGelada.id
																);
															}}
														>
															<i
																className="fa-solid fa-trash text-[18px] hover:text-lightBlue"
																title="Deletar"
															></i>
														</div>
													</DialogTrigger>
												</span>
											</td>
										</tr>
									)
							)}
						</tbody>
					</table>
					{
						pagination !== undefined &&
						<PaginationBar pagination={pagination} />
					}
				</div>

				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							Excluir {itemRemovido}?
						</DialogTitle>
					</DialogHeader>
					<DialogDescription>
						Todos os dados associados com {itemRemovido}{' '}
						serão removidos.
					</DialogDescription>
					<DialogFooter>
						<div
							className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
							onClick={() => deletar(idRemover)}
						>
							<DialogClose>Excluir</DialogClose>
						</div>
					</DialogFooter>
				</DialogContent>
			</Dialog>

			<AlertDialogContent>
				<form onSubmit={(e) => enviar(e)}>
					<AlertDialogHeader>
						<AlertDialogTitle>
							{funcaoModal} Sistema de água gelada
						</AlertDialogTitle>
					</AlertDialogHeader>
					<div className="w-full max-h-[500px] flex justify-around my-5 px-5 flex-wrap gap-5 overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-track-primary scrollbar-thumb-darkaccent">
						{/* NOME */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="nome"
							>
								Nome
							</label>
							<input
								id="nome"
								name="nome"
								type="text"
								placeholder="nome do sistema de água"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={nome}
								onChange={(e) =>
									setNome(e.target.value)
								}
								required
							/>
						</div>
						{/* VAZAO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="vazao"
							>
								Vazão
							</label>
							<input
								id="vazao"
								name="vazao"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={vazao}
								onChange={(e) =>
									setVazao(
										e.target.value
									)
								}
								required
							/>
						</div>

						{/* ACIONAMENTO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="acionamento"
							>
								Acionamento
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="acionamento"
								id="acionamento"
								required
								value={acionamento}
								onChange={(e) =>
									setAcionamento(
										e.target.value
									)
								}
							>
								<option label="   "></option>
								{
									tiposAcionamento.map((tipo, i) => (
										<option key={i} value={tipo}>{tipo}</option>	
									))
								}
							</select>
						</div>
						{/* TEMPERATURA ENTRADA */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="temperaturaEntrada"
							>
								Temperatura de entrada
							</label>
							<input
								id="temperaturaEntrada"
								name="temperaturaEntrada"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={temperaturaEntrada}
								onChange={(e) =>
									setTemperaturaEntrada(
										e.target.value
									)
								}
								required
							/>
						</div>

						{/* TEMPERATURA SAIDA */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="temperaturaSaida"
							>
								Temperatura de saída
							</label>
							<input
								id="temperaturaSaida"
								name="temperaturaSaida"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={temperaturaSaida}
								onChange={(e) =>
									setTemperaturaSaida(
										e.target.value
									)
								}
								required
							/>
						</div>
						{/* POTENCIA */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="potencia"
							>
								Potência
							</label>
							<input
								id="potencia"
								name="potencia"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={potencia}
								onChange={(e) =>
									setPotencia(
										e.target.value
									)
								}
								required
							/>
						</div>
			

						{/* MARCA */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="marcaId"
							>
								Marca
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="marcaId"
								id="marcaId"
								required
								value={marcaId}
								onChange={(e) =>
									setMarcaId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label="   "></option>
								{listaMarcas.map(
									(marca, i) => (
										<option
											value={
												marca.id
											}
											key={i}
										>
											{marca.nome}
										</option>
									)
								)}
							</select>
						</div>
						{/* MODELO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="modeloId"
							>
								Modelo
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="modeloId"
								id="modeloId"
								required
								value={modeloId}
								onChange={(e) =>
									setModeloId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label="   "></option>
								{listaModelos.map(
									(modelo, i) => (
										<option
											value={
												modelo.id
											}
											key={i}
										>
											{modelo.nome}
										</option>
									)
								)}
							</select>
						</div>
						{/* REGIME ID */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="regimeId"
							>
								Regime
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="regimeId"
								id="regimeId"
								required
								value={regimeId}
								onChange={(e) =>
									setRegimeId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label="   "></option>
								{listaRegimes
									.map((regime, i) => (
										<option
											value={
												regime.id
											}
											key={i}
										>
											{regime.nome}
										</option>
									))}
							</select>
						</div>
					</div>
					<AlertDialogFooter>
						<div className="flex w-full justify-end gap-x-4 p-4">
							<AlertDialogAction className="w-32">
								Confirmar
							</AlertDialogAction>
							<div onClick={onClose}>
								<AlertDialogCancel className="w-32">
									Cancelar
								</AlertDialogCancel>
							</div>
						</div>
					</AlertDialogFooter>
				</form>
			</AlertDialogContent>
		</>
	);
}
